import { Flex } from '@chakra-ui/react';
import { useTheme } from '@/contexts/ThemeProvider';

export function PrivacyPolicyPage() {
  const { privacyPolicy } = useTheme();

  if (privacyPolicy)
    return (
      <Flex width={'100%'} className="legal" paddingBottom={10}>
        <p style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: privacyPolicy }}></p>
      </Flex>
    );

  return (
    <Flex className="legal" paddingBottom={10}>
      <div className="text">
        <h2>Política de Privacidade</h2>
        <p>
          A PARTIU TECNOLOGIA E EDITORA ISPs LTDA e empresas do mesmo grupo ("PARTIU") reafirmam seu compromisso com a
          privacidade, segurança e proteção dos dados pessoais de seus usuários, clientes e parceiros.
        </p>
        <p>
          Esta Política de Privacidade tem como objetivo esclarecer de forma transparente como os dados pessoais são
          coletados, utilizados, armazenados e protegidos, em conformidade com a Lei nº 13.709/2018 (Lei Geral de Proteção
          de Dados – LGPD) e demais normas aplicáveis.
        </p>

        <h3>1. Abrangência</h3>
        <p>Esta Política aplica-se a todos os usuários que acessam ou utilizam:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>site</li>
          <li>aplicativos</li>
          <li>plataformas digitais da PARTIU</li>
        </ul>
        <p>
          O ambiente poderá conter links para sites de terceiros, cujas políticas de privacidade não são de responsabilidade
          da PARTIU, sendo recomendada a leitura dessas políticas antes do fornecimento de dados.
        </p>

        <h3>2. Dados Coletados</h3>
        <p>A PARTIU poderá coletar e tratar os seguintes dados pessoais:</p>

        <h4>2.1 Dados fornecidos pelo usuário</h4>
        <ul style={{marginLeft: '20px'}}>
          <li>Nome completo</li>
          <li>CPF</li>
          <li>E-mail</li>
          <li>Telefone</li>
          <li>Dados de login e autenticação</li>
        </ul>

        <h4>2.2 Dados recebidos de empresas contratantes (integração com ERPs)</h4>
        <p>
          A PARTIU poderá receber dados pessoais de empresas clientes (ex: provedores de internet), para viabilizar a
          execução contratual, incluindo:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>Nome</li>
          <li>CPF</li>
          <li>E-mail</li>
          <li>Identificador do usuário no sistema do cliente</li>
          <li>Plano contratado</li>
          <li>Data de início e término do plano</li>
          <li>Status do plano (ativo, suspenso ou cancelado)</li>
        </ul>
        <p>Esses dados são utilizados para:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>vincular o usuário aos conteúdos contratados</li>
          <li>liberar e controlar o acesso às obras editoriais</li>
          <li>garantir elegibilidade de uso</li>
          <li>registrar a disponibilização dos conteúdos</li>
        </ul>

        <h4>2.3 Dados de uso e registros (logs)</h4>
        <ul style={{marginLeft: '20px'}}>
          <li>Endereço IP</li>
          <li>Data e hora de acesso</li>
          <li>Dispositivo utilizado</li>
          <li>Interações na plataforma</li>
          <li>Registros de disponibilização de obras (download, envio por e-mail, acesso e leitura)</li>
        </ul>
        <p>Esses registros são essenciais para:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>segurança</li>
          <li>prevenção à fraude</li>
          <li>auditoria</li>
          <li>comprovação de disponibilização de conteúdo</li>
        </ul>

        <h3>3. Finalidade do Tratamento de Dados</h3>
        <p>Os dados pessoais são utilizados para:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>disponibilização de obras editoriais (ebooks, audiobooks e revistas digitais)</li>
          <li>autenticação e controle de acesso</li>
          <li>execução de contratos com empresas clientes</li>
          <li>integração com sistemas de terceiros (ERPs)</li>
          <li>registro e comprovação de entrega e disponibilização de conteúdo</li>
          <li>atendimento ao usuário</li>
          <li>comunicação institucional e operacional</li>
          <li>melhoria contínua da plataforma</li>
          <li>cumprimento de obrigações legais e regulatórias</li>
        </ul>

        <h3>4. Base Legal</h3>
        <p>O tratamento de dados pessoais ocorre com base nas seguintes hipóteses legais:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>execução de contrato</li>
          <li>cumprimento de obrigação legal ou regulatória</li>
          <li>legítimo interesse (segurança, prevenção à fraude, melhoria dos serviços)</li>
          <li>consentimento do titular, quando aplicável</li>
        </ul>

        <h3>5. Compartilhamento de Dados</h3>
        <p>Os dados pessoais poderão ser compartilhados com:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>empresas clientes contratantes (ex: provedores de internet)</li>
          <li>parceiros tecnológicos e fornecedores (hospedagem, infraestrutura, segurança)</li>
          <li>autoridades públicas, mediante obrigação legal</li>
        </ul>
        <p>
          A PARTIU não realiza a comercialização de dados pessoais.
        </p>

        <h3>6. Segurança da Informação</h3>
        <p>
          A PARTIU adota medidas técnicas e administrativas adequadas para proteção dos dados pessoais, incluindo:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>criptografia</li>
          <li>controle de acesso restrito</li>
          <li>monitoramento de sistemas</li>
          <li>políticas internas de segurança</li>
        </ul>
        <p>
          Os dados são armazenados em ambientes seguros e controlados, em conformidade com boas práticas de mercado.
        </p>

        <h3>7. Retenção de Dados</h3>
        <p>Os dados pessoais serão armazenados:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>durante a vigência da relação contratual</li>
          <li>pelo tempo necessário para cumprimento das finalidades</li>
          <li>conforme exigências legais</li>
        </ul>
        <p>
          Os registros (logs) poderão ser mantidos por período adicional para fins de:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>auditoria</li>
          <li>segurança</li>
          <li>defesa em processos administrativos ou judiciais</li>
        </ul>

        <h3>8. Direitos do Titular</h3>
        <p>
          Nos termos da LGPD, o titular dos dados poderá solicitar:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>confirmação da existência de tratamento</li>
          <li>acesso aos dados pessoais</li>
          <li>correção de dados incompletos ou desatualizados</li>
          <li>anonimização, bloqueio ou eliminação de dados desnecessários</li>
          <li>portabilidade dos dados</li>
          <li>revogação do consentimento</li>
        </ul>
        <p>
          As solicitações poderão ser realizadas por meio dos canais de atendimento da PARTIU.
        </p>

        <h3>9. Cookies e Tecnologias de Monitoramento</h3>
        <p>
          A PARTIU poderá utilizar cookies e tecnologias similares para:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>autenticação</li>
          <li>segurança</li>
          <li>análise de uso</li>
          <li>melhoria da experiência do usuário</li>
        </ul>
        <p>
          O usuário poderá gerenciar o uso de cookies por meio das configurações do navegador ou dispositivo.
        </p>

        <h3>10. Transferência Internacional de Dados</h3>
        <p>
          Caso haja transferência internacional de dados, a PARTIU garantirá a adoção de mecanismos adequados de proteção,
          conforme exigido pela legislação aplicável.
        </p>

        <h3>11. Aplicativos e Lojas (Google Play e App Store)</h3>
        <p>
          A utilização da plataforma por meio de aplicativos móveis poderá envolver coleta e tratamento de dados conforme
          descrito nesta Política.
        </p>
        <p>
          A PARTIU observa as diretrizes e requisitos de privacidade exigidos pelas lojas de aplicativos, incluindo:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>Google Play</li>
          <li>App Store (Apple)</li>
        </ul>
        <p>
          O usuário também estará sujeito às políticas dessas plataformas.
        </p>

        <h3>12. Atualizações desta Política</h3>
        <p>
          Esta Política poderá ser atualizada a qualquer momento para refletir melhorias ou alterações legais.
        </p>
        <p>
          Quando houver mudanças relevantes:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>será publicado aviso na plataforma</li>
          <li>usuários poderão ser comunicados por meios eletrônicos</li>
        </ul>

        <h3>13. Canal de Atendimento (Encarregado de Dados – DPO)</h3>
        <p>
          Para dúvidas, solicitações ou exercício de direitos relacionados à proteção de dados, o usuário poderá entrar
          em contato por meio do canal:
        </p>
        <p>
          📧 ajuda@partiu.com.br
        </p>
      </div>
    </Flex>
  );
}
